/* eslint-disable @typescript-eslint/no-explicit-any */
import { computed, ref, Ref } from "vue";
import { selectQuery } from "./helpers";
import {
  SegmentProps,
  GalleryProps,
  HomeProps,
  CollectionProps,
} from "./types";

type UseContentLoad = { contentType: string; slug?: string | string[] };

export const useContent = () => {
  const result: Ref<
    SegmentProps | GalleryProps | HomeProps | CollectionProps | null
  > = ref(null);
  const loading: Ref<boolean> = ref(false);
  const error: any = ref({ load: null });

  const spaceId = process.env.VUE_APP_CONTENT_SPACE_ID;
  const deliveryToken = process.env.VUE_APP_CONTENT_DELIVERY_TOKEN;

  const load = async ({ contentType, slug }: UseContentLoad) => {
    try {
      loading.value = true;
      const query = selectQuery(contentType, slug);
      const url = `https://graphql.contentful.com/content/v1/spaces/${spaceId}/environments/master`;

      const body: Record<string, any> = { query };

      // This allows us to filter collections by tag / slug
      if (contentType === "collections" && slug?.length) {
        body.variables = { tag: slug };
      }

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          "content-type": "application/JSON",
          authorization: `Bearer ${deliveryToken}`,
        },
        body: JSON.stringify(body),
      });

      const response = await fetchResponse.json();
      result.value = {
        id: contentType,
        ...response?.data?.[`${contentType}Collection`]?.items?.[0],
        // This auto fetches appropriate galleries for the collections content type
        ...(response?.data?.["galleryCollection"] &&
          (contentType === "collections" || contentType === "home") && {
            galleries: { ...response?.data?.["galleryCollection"] },
          }),
      };
      error.value.load = null;
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
  };

  return {
    load,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
  };
};
